export const getStyled = (theme) => ({
  messagesListWrapper: {
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    width: '100%',
    minWidth: 300,
    minHeight: 200,
  },

  currentTick: {
    alignItems: 'center',
    textAlign: 'center',
    alignSelf: 'center',
    backgroundColor: theme.palette.mode === 'light' ? '#a7a7a7' : '#15202B',
    margin: '10px',
    borderRadius: '10px',
    boxShadow: `1px 1px 6px  ${theme.palette.mode === 'light' ? '#15202B' : '#b3b3b3'}`,
    width: '97%',
  },

  currentTicktText: {
    fontWeight: 'bold',
    padding: 8,
    alignSelf: 'center',
    marginLeft: '0px',
    color: theme.primaryColor,
    borderRadius: '8px',
    boxShadow: '',
  },

  messagesList: {
    backgroundColor: theme.custom.colors.defaultBackground,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    width: '100%',
    padding: '20px 20px 30px 20px',
    overflowY: 'auto',
    overflowX: 'hidden',
    ...theme.custom.scrollbarStyles,
  },

  dragElement: {
    background: 'rgba(255, 255, 255, 0.8)',
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 999999,
    textAlign: 'center',
    fontSize: '3em',
    border: '5px dashed #333',
    color: '#333',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  circleLoading: {
    color: '#2196f3',
    position: 'absolute',
    opacity: '70%',
    top: 0,
    left: '50%',
    marginTop: 12,
  },

  divLoading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  messageLeft: {
    marginRight: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 400,
    height: 'auto',
    display: 'block',
    position: 'relative',
    '&:hover #messageActionsButton': {
      visibility: 'visible',
      pointerEvents: 'all',
      display: 'flex',
      position: 'absolute',
      top: 0,
      right: 0,
    },
    whiteSpace: 'pre-wrap',
    backgroundColor: theme.palette.mode === 'light' ? '#dadada' : '#3A505E',
    color: theme.palette.mode === 'light' ? '#303030' : '#ffffff',
    alignSelf: 'flex-start',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 8,
    paddingBottom: 8,
    boxShadow:
      theme.palette.mode === 'light'
        ? '0 1px 1px #b3b3b3'
        : '0 1px 1px #000000',
    fontFamily: 'Tahoma, sans-serif',
    fontSize: 14,
  },

  quotedContainerLeft: {
    margin: '-3px -80px 6px -6px',
    overflow: 'hidden',
    backgroundColor: theme.palette.mode === 'light' ? '#f0f0f0' : '#1d282f',
    borderRadius: '7.5px',
    display: 'flex',
    position: 'relative',
    fontFamily: 'Tahoma, sans-serif',
  },

  quotedMsg: {
    padding: 10,
    maxWidth: 300,
    height: 'auto',
    display: 'block',
    whiteSpace: 'pre-wrap',
    overflow: 'hidden',
  },

  quotedSideColorLeft: {
    flex: 'none',
    width: '4px',
    backgroundColor: theme.palette.mode === 'light' ? '#065183' : '#6bcbef',
  },

  messageRight: {
    marginLeft: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 400,
    height: 'auto',
    display: 'block',
    position: 'relative',
    whiteSpace: 'pre-wrap',
    backgroundColor: theme.palette.mode === 'light' ? '#dcf8c6' : '#008068',
    color: theme.palette.mode === 'light' ? '#303030' : '#ffffff',
    alignSelf: 'flex-end',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 0,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 8,
    paddingBottom: 8,
    boxShadow:
      theme.palette.mode === 'light'
        ? '0 1px 1px #727272'
        : '0 1px 1px #000000',
    fontFamily: 'Tahoma, sans-serif',
    fontSize: 14,
  },

  messageRightPrivate: {
    marginLeft: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: '100%',
    height: 'auto',
    display: 'block',
    position: 'relative',
    whiteSpace: 'pre-wrap',
    backgroundColor: '#c9c9c9',
    color: '#303030',
    alignSelf: 'center',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 3,
    paddingRight: 3,
    paddingTop: 3,
    paddingBottom: 0,
    boxShadow:
      theme.palette.mode === 'light'
        ? '0 1px 1px #727272'
        : '0 1px 1px #000000',
    fontFamily: 'Tahoma, sans-serif',
    fontSize: 14,
  },

  quotedContainerRight: {
    margin: '-3px -80px 6px -6px',
    overflowY: 'hidden',
    backgroundColor: theme.palette.mode === 'light' ? '#cfe9ba' : '#025144',
    borderRadius: '7.5px',
    display: 'flex',
    position: 'relative',
    fontFamily: 'Tahoma, sans-serif',
  },

  quotedMsgRight: {
    padding: 10,
    maxWidth: 300,
    height: 'auto',
    whiteSpace: 'pre-wrap',
    fontFamily: 'Tahoma, sans-serif',
  },

  quotedSideColorRight: {
    flex: 'none',
    width: '4px',
    backgroundColor: '#35cd96',
  },

  messageActionsButtonInactiveLeft: {
    top: 0,
    right: 0,
    position: 'absolute',
    visibility: 'hidden',
    pointerEvents: 'none',
    color: '#999',
    zIndex: 1,
    backgroundColor: 'inherit',
    opacity: '90%',
    '&:hover, &.MuiFocusVisible': { backgroundColor: 'inherit' },
  },

  messageActionsButtonInactiveRight: {
    top: 0,
    left: 0,
    position: 'absolute',
    visibility: 'hidden',
    pointerEvents: 'none',
    color: '#999',
    zIndex: 1,
    backgroundColor: 'inherit',
    opacity: '90%',
    '&:hover, &.MuiFocusVisible': { backgroundColor: 'inherit' },
  },

  messageActionsLeft: {
    visibility: 'visible',
    pointerEvents: 'all',
    display: 'flex',
    position: 'absolute',
    top: 0,
    right: 0,
    color: '#999',
    zIndex: 1,
    backgroundColor: 'inherit',
    opacity: '90%',
    '&:hover, &.MuiFocusVisible': {
      backgroundColor: `rgba(189, 189, 189, ${theme.palette.mode === 'light' ? '0.6' : '0.2'})`,
    },
  },

  messageActionsRight: {
    color: '#999',
    zIndex: 1,
    backgroundColor: 'inherit',
    opacity: '90%',
    visibility: 'visible',
    pointerEvents: 'all',
    display: 'flex',
    position: 'absolute',
    top: 0,
    left: 0,

    '&:hover, &.MuiFocusVisible': {
      backgroundColor: `rgba(189, 189, 189, ${theme.palette.mode === 'light' ? '0.4' : '0.25'})`,
    },
  },

  messageContactName: {
    display: 'flex',
    color: theme.palette.mode === 'light' ? '#065183' : '#6bcbef',
    fontWeight: 500,
  },

  textContentItem: {
    overflowWrap: 'break-word',
    padding: '3px 80px 6px 6px',
  },

  textContentItemDeleted: {
    fontStyle: 'italic',
    color: 'rgba(0, 0, 0, 0.36)',
    overflowWrap: 'break-word',
    padding: '3px 80px 6px 6px',
  },

  messageMedia: {
    objectFit: 'cover',
    width: 'auto',
    maxWidth: 350,
    height: 'auto',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },

  timestamp: {
    fontSize: 11,
    position: 'absolute',
    bottom: 0,
    right: 7,
    color: '#999',
  },

  forwardMessage: {
    fontSize: 14,
    fontStyle: 'italic',
    position: 'absolute',
    top: 0,
    left: 5,
    color: '#999',
    display: 'flex',
    alignItems: 'center',
  },

  dailyTimestamp: {
    alignItems: 'center',
    textAlign: 'center',
    alignSelf: 'center',
    width: '110px',
    backgroundColor: '#e1f3fb',
    margin: '10px',
    borderRadius: '10px',
    boxShadow: '0 1px 1px #b3b3b3',
  },

  dailyTimestampText: {
    color: '#808888',
    padding: 8,
    alignSelf: 'center',
    marginLeft: '0px',
  },

  ackIcons: {
    fontSize: 18,
    verticalAlign: 'middle',
    marginLeft: 4,
  },

  deletedIcon: {
    fontSize: 18,
    verticalAlign: 'middle',
    marginRight: 4,
  },

  ackDoneAllIcon: {
    color: '#1DA1F2',
    fontSize: 18,
    verticalAlign: 'middle',
    marginLeft: 0.5,
  },

  ackPlayedIcon: {
    color: '#4caf50',
    fontSize: 18,
    verticalAlign: 'middle',
    marginLeft: 0.5,
  },
  downloadMedia: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'inherit',
    padding: 10,
    color:
      theme.palette.mode === 'light'
        ? theme.custom.colors.light
        : theme.custom.colors.dark,
  },

  messageCenter: {
    marginTop: 5,
    alignItems: 'center',
    verticalAlign: 'center',
    alignContent: 'center',
    backgroundColor: '#E1F5FEEB',
    fontSize: 14,
    minWidth: 100,
    maxWidth: 270,
    color: '#272727',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: '0 1px 1px #b3b3b3',
  },

  deletedMessage: {
    color: '#b8b8b8',
    fontStyle: 'italic',
  },

  reactionLeft: {
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15,
    backgroundColor: theme.palette.mode === 'light' ? '#cacaca' : '#2a3a44',
    color: theme.palette.mode === 'light' ? '#303030' : '#ffffff',
    position: 'absolute',
    left: '0',
    bottom: '0',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '2px 2px 4px rgba(0,0,0,0.5)',
    transform: 'translate(5%, 45%)',
    lineHeight: 1,
    fontSize: 14,
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.9,
      boxShadow: '2px 2px 6px rgba(0,0,0,0.7)',
    },
  },

  reactionRight: {
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15,
    backgroundColor: theme.palette.mode === 'light' ? '#afd691' : '#005f4e',
    color: theme.palette.mode === 'light' ? '#303030' : '#ffffff',
    position: 'absolute',
    left: '0',
    bottom: '0',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '2px 2px 4px rgba(0,0,0,0.5)',
    transform: 'translate(5%, 45%)',
    lineHeight: 1,
    fontSize: '12px',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.9,
      boxShadow: '2px 2px 6px rgba(0,0,0,0.7)',
    },
  },
});
